// import scss
import "./styles.scss";

import $ from "cash-dom"; // jQuery alternative
// import axios from 'axios'; // ajax http request lib
import dayjs from 'dayjs'; // date manipulation lib
import 'dayjs/locale/nl'; // locales for dayjs
// import {
//     Event,
//     Element,
//     Collapse,
//     Tooltip,
//     Modal
// } from 'bootstrap'; // bootstrap utils

// // set nl locale on dayjs
dayjs.locale('nl');

const currency_transformer = new Intl.NumberFormat('nl-NL');

function recalculate() {
    const total_price_elm = $('strong.trip-total-price');
    const advance_payment_elm = $('span.advance-payment-amount');
    const remaining_price_elm = $('span.remaining-amount');

    let total_price = parseInt(total_price_elm.data('original-price'), 10);

    $('div.extras > div.extra input[type="checkbox"]').each((idx, checkboxEl) => {
        if (checkboxEl.checked) {
            console.log('checked');
            total_price += parseInt($(checkboxEl).attr('price'), 10);
        }
    });

    total_price_elm.html(currency_transformer.format(total_price));

    if (remaining_price_elm.length > 0 && advance_payment_elm.length > 0) {
        const advance_payment = parseInt(advance_payment_elm.data('advance-amount'), 10);
        let remaining_price = total_price - advance_payment
        remaining_price_elm.html(currency_transformer.format(remaining_price));
    }
}


// execute on dom:loaded
$(function() {
    console.log('hello at document ready from index.js');

    $('div.extras > div.extra input[type="checkbox"]').on('change', (e) => {
        recalculate();  // recalculate after checkbox change
    });

    recalculate();  // recalculate on page load

    // prevent double click on submit
    $('form[name="book_request_form"]').on('submit', (e) => {

        // disable submit button in 50ms
        window.setTimeout(() => {
            $('#book_request_form_confirm').attr('disabled', 'disabled');
            // $('#book_request_form_confirm').addClass('btn--disabled');
            $('#book_request_form_confirm').html('Bezig met verwerken...');

            // re-enable submit button after 5 seconds
            window.setTimeout(() => {
                $('#book_request_form_confirm').removeAttr('disabled');
                // $('#book_request_form_confirm').removeClass('btn--disabled');
                $('#book_request_form_confirm').html('Inschrijven');
            }, 5000);
        }, 50);

        // return false;
        return e;
    });


    // // ## ######## ##
    // // ## Tooltips ##
    // // ## ######## ##
    // $('[data-bs-toggle="tooltip"]').each((idx, tooltipTriggerEl) => {
    //     console.info('initialize tooltip');
    //     return new Tooltip(tooltipTriggerEl);
    // });

});
